<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>赠送优惠券</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="_closebuyGoldSendParking()"
            >
              <i class="el-icon-close"></i> 返回
            </el-button>
          </div>
          <div class="card-body">
            <el-form label-position="right" label-width="120px">
              <el-form-item label="优惠券">
                <el-input
                  v-model="buyGoldSendParkingInfo.couponName"
                  disabled
                  placeholder="优惠券"
                ></el-input>
              </el-form-item>
              <el-form-item label="库存">
                <el-input
                  v-model="buyGoldSendParkingInfo.stock"
                  disabled
                  placeholder="库存"
                ></el-input>
              </el-form-item>
              <el-form-item label="赠送数量">
                <el-input
                  v-model.number="buyGoldSendParkingInfo.giftsCostMoney"
                  type="number"
                  @change="_changeGoldCount()"
                  placeholder="必填，请填写购买赠送数量"
                ></el-input>
              </el-form-item>
              <el-form-item label="车牌号">
                <el-input
                  v-model="buyGoldSendParkingInfo.licensePlate"
                  placeholder="车牌号请填写准确，否则道闸无法识别"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话">
                <el-input
                  v-model="buyGoldSendParkingInfo.tel"
                  placeholder="电话请填写正确手机号"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          type="primary"
          class="float-right"
          @click="_tobuyGoldSendParking()"
        >
          <i class="el-icon-check"></i>&nbsp;赠送
        </el-button>
      </el-col>
    </el-row>

    <choose-shop-vip-user
      ref="chooseShopVipUser"
      @chooseShopVipUser="handleChooseShopVipUser"
    ></choose-shop-vip-user>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { getCouponShopPoolList, saveSendParking } from '@/api/goods/buyGoldSendParkingApi'
import ChooseShopVipUser from '@/components/goods/chooseShopVipUser/chooseShopVipUser.vue'

export default {
  components: {
    ChooseShopVipUser
  },
  data() {
    return {
      buyGoldSendParkingInfo: {
        spId: '',
        actualPrice: '0',
        couponName: '0',
        stock: '0',
        giftsCostMoney: '1',
        licensePlate: '',
        tel: '',
        shopId: getShopId(),
        showRefresh: false
      }
    }
  },
  created() {
    this.buyGoldSendParkingInfo.spId = this.$route.query.spId
    this._listProducts()
  },
  methods: {
    async _listProducts() {
      try {
        const res = await getCouponShopPoolList({
          page: 1,
          spId: this.buyGoldSendParkingInfo.spId,
          row: 1
        })
        Object.assign(this.buyGoldSendParkingInfo, res.data[0])
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _closebuyGoldSendParking() {
      this.$router.go(-1)
    },
    _changeGoldCount() {
      if (this.buyGoldSendParkingInfo.stock - this.buyGoldSendParkingInfo.giftsCostMoney < 0) {
        this.$message.warning('库存不足，请先购买优惠卷！')
      }
    },
    async _tobuyGoldSendParking() {
      if (this.buyGoldSendParkingInfo.stock - this.buyGoldSendParkingInfo.giftsCostMoney < 0) {
        this.$message.warning('库存不足，请先购买优惠卷！')
        return
      }

      try {
        const res = await saveSendParking(this.buyGoldSendParkingInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._closebuyGoldSendParking()
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error(error)
      }
    },
    handleChooseShopVipUser(shopVipUser) {
      console.log(shopVipUser)
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}
.card-body {
  padding: 20px;
}
</style>